export default __webpack_public_path__ + "static/media/7.a523d603.png";